module.exports = __webpack_public_path__ + "static/img/enki.bdc9fe2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/introduction/img/enki.png
// module id = iXtm
// module chunks = 0